import axios from 'axios'

const { url } = window.__REACT_WORDPRESS__.routing
const BLOG_URL = `${url}/wp-json/wp/v2/release?per_page=10&_embed`

export const getBlogPosts = async () => {
  const { data } = await axios.get(BLOG_URL)

  return data.map((post) => ({
    id: post.id,
    title: post.title?.rendered ?? '',
    excerpt: post.excerpt?.rendered || post.content?.rendered,
    url: post.link,
    featuredImage: post._embedded?.['wp:featuredmedia']?.[0]?.source_url || null,
  }))
}
